import React from "react"
import * as styles from "./NewPricingCard.module.scss"
import { Link } from "gatsby"
import { RenderRichContent } from "../RenderRichContent/RenderRichContent"

const NewPricingCard = props => {
  const data = props.data
  const index = props.index

  const bgColor =
    props.licenseType === "START"
      ? "bg-[#99b1c7] text-white"
      : props.licenseType === "PRO"
        ? "bg-[#6a87a2] text-white "
        : props.licenseType === "SecurEd"
          ? "bg-[#000000] text-white"
          : "bg-[#436688] text-white "

  return (
    <>
      {/* start card */}
      {props.licenseType === "SecurEd" ? (
        <div
          className={`w-full mx-auto text-center rounded-md overflow-hidden bg-white h-full pb-9 lg:w-[30%] lg:mb-0 mb-8 relative ${props.addStyling ? props.addStyling : ""} `}
        >
          <div className={`min-h-[650px] flex flex-col justify-start h-full`}>
            <div className={`px-4 py-3 min-h-[65px] ` + bgColor}>
              <h3 className={`font-bold font-sans text-[18px] mb-1 `}>
                {props.licenseDescription}
                <h6 className="font-normal font-sans text-[18px] m-0">
                  {props.licenseType}
                </h6>
              </h3>
            </div>
            <div
              className={`flex gap-1 flex-col w-3/4 mx-auto min-h-[150px] + ${styles.quoteText}`}
            >
              <div className="flex flex-col justify-center items-center mt-3 mb-6 gap-2">
                <h3 className="text-black font-sans font-[900] text-[38px] mb-0">
                  {/* <span className="text-[18px] m-1">{props.data.node_locale === "en" ? props.eur : props.gbp}</span> */}
                  <span className="text-[24px] m-1">{props.currencyValue}</span>

                  {props.price}
                </h3>
                <p className="font-normal font-sans text-[18px] font-bold m-0">
                  {props.paymentCondition}
                </p>
              </div>
              <Link
                to={`/${props.demoPageSlug}`}
                className="flex gap-1 text-[16px] font-sans my-3 justify-center"
              >
                <p className="bg-[#006ef5]  hover:bg-[#00469d] px-8 py-4 rounded-full text-[white] font-[600]">
                  {props.talkToSales}
                </p>
              </Link>
            </div>
            <div className={styles.listItemsSecureEd}>
              <RenderRichContent content={props.featureList} />
            </div>
          </div>
        </div>
      ) : (
        <div className="w-full mx-auto text-center rounded-md overflow-hidden bg-white h-full pb-9 lg:w-[30%] lg:mb-0 mb-8 relative shadow-2xl"
>
          <div
            className={`lg:min-h-[650px] md:h-[750px] flex flex-col justify-start h-full`}
          >
            <div className={`px-4 py-3 min-h-[70px] ` + bgColor}>
              <h3 className={`font-bold font-sans text-[18px] mb-1 `}>
                {props.licenseType}
              </h3>
              <h6 className="font-normal font-sans text-[18px] m-0">
                {props.licenseDescription}
              </h6>
            </div>
            <div className="flex flex-col justify-center items-center mt-3 mb-6 gap-2">
              <h3 className="text-black font-sans font-[900] text-[38px] mb-0">
                {/* <span className="text-[18px] m-1">{props.data.node_locale === "en" ? props.eur : props.gbp}</span> */}
                <span className="text-[24px] m-1">{props.currencyValue}</span>

                {props.price}
              </h3>
              <p className="font-normal font-sans text-[18px] font-bold m-0">
                {props.paymentCondition}
              </p>
            </div>
            <div className="flex gap-1 flex-col w-3/4 mx-auto">
              <Link
                to={`/${props.openWebShopSlug + props.queryAddon}`}
                className="px-4 py-4 font-sans font-bold text-white rounded-full text-[16px] bg-[#006ef5]  hover:bg-[#00469d] transition-shadow"
              >
                {
                  props.data.newLicenseInformation[index]
                    .chooseLicenseButtonText
                }
              </Link>
              <Link
                to={`/${props.freeTrialSlug}`}
                className="flex gap-1 text-[16px] font-sans my-3 justify-center"
              >
                <span>
                  {data.node_locale === "nl"
                    ? "of"
                    : data.node_locale === "de"
                      ? "oder"
                      : "or"}
                </span>
                <p className="underline mb-0">
                  {/* {data.newLicenseInformation[index].buttonTextFreeTrial} */}
                  {data.node_locale === "nl"
                    ? "Start free trial"
                    : data.node_locale === "de"
                      ? "Free Trial starten"
                      : "Start free trial"}
                </p>
              </Link>
            </div>
            {props.licenseType === "START" ? (
              <div className={styles.listItemsStart}>
                <RenderRichContent content={props.featureList} />
              </div>
            ) : props.licenseType === "PRO" ? (
              <div className={styles.listItemsPro}>
                <RenderRichContent content={props.featureList} />
              </div>
            ) : (
              <div className={styles.listItemsExpert}>
                <RenderRichContent content={props.featureList} />
              </div>
            )}
          </div>
        </div>
      )}
      {/* end card */}
    </>
  )
}

export default NewPricingCard
